<div class="lp-mobile-block" *ngIf="isMobile">
  <div class="lp-mobile-card">
    <!-- Headline at the very top -->
    <h1 class="lp-head">
      Welcome&nbsp;to&nbsp;the
      <br />
      Future&nbsp;of&nbsp;Lending
    </h1>

    <!-- Centerpiece: tagline with particles -->
    <div class="lp-centerpiece">
      <div class="lp-particle-bg">
        <canvas #particleCanvas></canvas>
        <h2 class="lp-tagline">INTERACTIVE. VISUAL. POWERFUL.</h2>
      </div>
    </div>

    <!-- LendPeak explanation -->
    <p class="lp-about">
      Dive into a live sandbox of advanced loan scenarios. Visualize, experiment&nbsp;&amp;&nbsp;innovate with the most
      modern lending engine – right in your browser.
    </p>

    <!-- Modern mobile unsupported reason -->
    <div class="lp-reason">
      <div class="lp-reason-title">
        Screen Too Small
        <span aria-label="mobile" style="font-size: 1.1em">📱</span>
      </div>
      <div class="lp-reason-text">
        LendPeak's dashboards are dense, interactive, and require a large display for the best experience.
        <br />
        <strong>Please use a desktop or large tablet</strong>
        to access the full power of LendPeak Servicing.
      </div>
    </div>

    <!-- Socials -->
    <div class="lp-socials">
      <a href="https://github.com/LendPeak/LendPeak" aria-label="GitHub" target="_blank">
        <i class="pi pi-github"></i>
      </a>
      <a href="https://www.facebook.com/lendpeak/" aria-label="Facebook" target="_blank">
        <i class="pi pi-facebook"></i>
      </a>
      <a href="https://x.com/lendpeak/" aria-label="X / Twitter" target="_blank"><i class="pi pi-twitter"></i></a>
    </div>
  </div>
</div>
